// 由 scripts/extract-legacy-tables.ts 產生，不要手改。
// 重跑：bunx tsx scripts/extract-legacy-tables.ts [rawDomLegacyRoot]
//
// 來源：.tmp/ui/raw-dom/legacy/admin/<module>/<pageId>.html（原系統實測 DOM，唯讀基準證據）。
//       143 頁裡 7 頁通過欄形一致性閘門，
//       其中 5 頁的第一欄表頭是空字串——那是原系統放操作連結的欄位。
//
// 與 legacy-table-headers.generated.ts 的分工：
//   - legacy-table-headers 決定**有哪些資料欄**（空表頭已被濾掉），假資料依它產生；
//   - 這個檔決定**表格的形狀**：表頭原貌（含空字串）與每一欄的儲存格形態。
// 兩者來源不同（前者是 dom.json，後者是 raw-dom），所以不合併成一個檔。
//
// 只有形狀，沒有任何儲存格內容（TEST-DATA-AND-PII-POLICY §4）。

/** 一欄的儲存格在原系統長什麼樣。同一欄各列不一致時取最強的（link > control > text > blank）。 */
export type LegacyCellShape = 'blank' | 'text' | 'control' | 'link';

export interface LegacyTableShape {
  /** 原系統該表格的表頭原貌，含空字串。 */
  readonly headers: readonly string[];
  /** 與 headers 同序、同長度。 */
  readonly shapes: readonly LegacyCellShape[];
}

/** pageId → 原系統該頁清單表格的形狀。 */
export const LEGACY_TABLES: Readonly<Record<string, LegacyTableShape>> = {
  'config-annual': {
    headers: ['', '年度', '是否預設', '排序', '狀態'],
    shapes: ['link', 'link', 'link', 'text', 'link'],
  },
  'config-department': {
    headers: ['', '部門代碼', '部門名稱', '排序', '狀態'],
    shapes: ['blank', 'text', 'link', 'text', 'text'],
  },
  'config-location': {
    headers: ['', '醫院', '管轄部門', '地點類別', '地點代碼', '地點名稱', '地點照片', '排序', '狀態'],
    shapes: ['link', 'text', 'text', 'text', 'text', 'link', 'blank', 'text', 'link'],
  },
  'config-organization': {
    headers: ['', '組織類型', '組織代碼', '組織名稱', '組織簡稱', '排序', '狀態'],
    shapes: ['blank', 'text', 'text', 'link', 'text', 'text', 'text'],
  },
  'config-role': {
    headers: ['', '排序', '角色名稱', '說明', '權限設定'],
    shapes: ['blank', 'text', 'link', 'text', 'link'],
  },
  'report-tsgh-core-skill-statistic-report': {
    headers: ['總和', '', '', ''],
    shapes: ['text', 'blank', 'blank', 'blank'],
  },
  'system-about': {
    headers: ['名稱', '來源'],
    shapes: ['text', 'text'],
  },
};
